module.exports = __webpack_public_path__ + "static/img/zhong21.05880c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong21.png
// module id = JuXL
// module chunks = 16